import { render, staticRenderFns } from "./background-image-size.vue?vue&type=template&id=e997b65c&"
import script from "./background-image-size.vue?vue&type=script&lang=js&"
export * from "./background-image-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports